import RoundedButton from '@shared/components/RoundedButton';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import AppTheme from '@libs/mui/AppTheme';
import { Stack } from '@mui/material';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import PhoneInTalkOutlinedIcon from '@mui/icons-material/PhoneInTalkOutlined';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';

export const ClientContactButtons = (props: { phone: string; phonePrefix?: string | null; onMakeOrder: () => void }) => {
  const { phone, phonePrefix, onMakeOrder } = props;
  const prefix = phonePrefix ?? '+420';
  const { t } = useIntlTranslations('clientProfilePage');
  return (
    <Stack direction="row" margin={0} spacing={0} alignItems="center" justifyContent="center">
      <RoundedButton
        icon={<SmsOutlinedIcon color="info" />}
        sx={{ backgroundColor: '#bee3ff9b' }}
        href={`sms:${prefix}${phone}`}
        text={t('sms')}
      />
      <RoundedButton
        href={`tel:${prefix}${phone}`}
        icon={<PhoneInTalkOutlinedIcon color="success" />}
        sx={{ backgroundColor: `${AppTheme.palette.success.light}` }}
        text={t('call')}
      />
      <RoundedButton
        icon={<EditCalendarIcon color="primary" />}
        sx={{ backgroundColor: `${AppTheme.palette.primary.light}` }}
        text={t('makeOrder')}
        onClick={onMakeOrder}
      />
    </Stack>
  );
};
